import { Injectable } from '@angular/core';
import { ApiCustomerService } from '../api-services/customer.api.service';
import { Customer } from '../models/Customer';
import { MessagesService } from './messages.service';
import { ModalController, AlertController } from '@ionic/angular';
import { PackagePurchaseModalPage } from '../modals/package-purchase-modal/package-purchase-modal.page';
import { euCountryList } from '../../assets/content/eucountries';
import { ukList } from '../../assets/content/ukLocations';
import { Observable } from '../../../node_modules/rxjs';
import { API_SETTINGS } from '../api-services/API_SETTINGS';
import { HttpClient } from '../../../node_modules/@angular/common/http';
import { DatePipe } from '../../../node_modules/@angular/common';
import { ApiCustomerUsageService } from '../api-services/customer-usage.api.service';
import { CustomerUsageLimit } from '../models/usage/CustomerUsageLimit';
import { CryptoService } from './crypto.service';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {

    public customers: any = [];
    public customer: Customer;
    public hasExpired: boolean;
    public _isModalOpen: boolean;
    public euList = euCountryList;
    public ukList = ukList;

    public customerFilter = {
        name: ''
    };

    constructor(
        public ApiCustomerService: ApiCustomerService,
        public ApiCustomerUsageService: ApiCustomerUsageService,
        public messagesService: MessagesService,
        public modalController: ModalController,
        public alertController: AlertController,
        public httpClient: HttpClient,
        public cryptoService: CryptoService
    ) {
    }

    async presentUpsertCustomerUsage(customer) {
        this.ApiCustomerUsageService.getCustomerUsageLimitByCustomerId(customer.customerId).subscribe(usage => {
            const alert = this.alertController.create({
                header: 'Edit ' + customer.name + ' Usage',
                subHeader: "Update your usage limits for this customer using the below fields;",
                message: "<ul><li>Streaming Usage</li><li>Max LRS Users</li><li>File Storage</li><li>Max Users</li></ul>",
                inputs: [
                    {
                        name: 'streamingUsage',
                        type: 'number',
                        label: 'Streaming usage:',
                        placeholder: 'Streaming usage.',
                        value: usage.streamingUsage
                    },
                    {
                        name: 'maxLrsUsers',
                        type: 'number',
                        label: 'Max LRS users:',
                        placeholder: 'Max LRS users.',
                        value: usage.maxLrsUsers
                    },
                    {
                        name: 'fileStorage',
                        type: 'number',
                        label: 'File storage:',
                        placeholder: 'File storage.',
                        value: usage.fileStorage
                    },
                    {
                        name: 'maxUsers',
                        type: 'number',
                        label: 'Max users:',
                        placeholder: 'Max users.',
                        value: usage.maxUsers
                    }
                ],
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {

                        }
                    }, {
                        text: 'Save',
                        handler: (data) => {
                            usage.fileStorage = parseInt(data.fileStorage);
                            usage.maxLrsUsers = parseInt(data.maxLrsUsers);
                            usage.maxUsers = parseInt(data.maxUsers);
                            usage.streamingUsage = parseInt(data.streamingUsage);

                            this.ApiCustomerUsageService.postCustomerUsageLimitByCustomerId(usage).subscribe(a => {
                                this.messagesService.loadingWindow.dismiss();
                                this.messagesService.displayToastWithMessage("Customer usage limits updated", "customer usage limits updated successfully");
                            });
                        }
                    }
                ]
            }).then(a => {
                a.present();
            });
        });
    }

    async presentUpsertCustomer(customer) {
        var date = customer != null ? new Date(customer.expiryDate) : new Date(Date.parse(Date()));
        var expiryDatePipe = new DatePipe('en-GB'); // Use your own locale
        var expiryDateFormatted = expiryDatePipe.transform(date, 'yyyy-MM-dd');
        //console.log(expiryDateFormatted);

        const alert = await this.alertController.create({
            header: customer != null ? 'Edit ' + customer.name : 'Add New Customer',
            inputs: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Customer name:',
                    placeholder: 'Customer name.',
                    value: customer != null ? customer.name : ""
                },
                {
                    name: 'domainName',
                    type: 'text',
                    label: 'Customer domain:',
                    placeholder: 'Customer domain.',
                    value: customer != null ? customer.domainName : ""
                },
                {
                    name: 'country',
                    type: 'text',
                    label: 'Customer country:',
                    placeholder: 'Customer country.',
                    value: customer != null ? customer.country : "United Kingdom"
                },
                {
                    name: 'dateFormat',
                    type: 'text',
                    label: 'Customer date format:',
                    placeholder: 'Customer date format.',
                    value: customer != null ? customer.dateFormat : "EU"
                },
                {
                    name: 'blobStorageLocation',
                    type: 'text',
                    label: 'Customer blob storage location:',
                    placeholder: 'Customer blob storage location.',
                    value: customer != null ? customer.blobStorageLocation : "UK"
                },
                {
                    name: 'licenseType',
                    type: 'text',
                    label: 'Customer license type:',
                    placeholder: 'Customer license type.',
                    value: customer != null ? customer.licenseType : "Trial"
                },
                {
                    name: 'expiryDate',
                    type: 'date',
                    label: 'Customer expiry date:',
                    placeholder: 'Customer expiry date.',
                    value: expiryDateFormatted
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {

                    }
                }, {
                    text: customer != null ? 'Save' : 'Add',
                    handler: (data) => {
                        //console.log(JSON.stringify(data));
                        var customerData = {
                            "customerId": customer != null ? customer.customerId : 0,
                            "name": data.name,
                            "domainName": data.domainName,
                            "country": data.country,
                            "dateFormat": data.dateFormat,
                            "expiryDate": data.expiryDate,
                            "licenseType": data.licenseType,
                            "blobStorageLocation": data.blobStorageLocation
                        };

                        if (customer != null) {
                            this.ApiCustomerService.updateCustomer(customer.customerId, customerData).subscribe(o => {
                                this.getCustomers();
                                this.messagesService.loadingWindow.dismiss();
                                this.messagesService.displayToastWithMessage("Customer edited", "customer edited successfully");
                            });
                        }
                        else {
                            this.ApiCustomerService.addCustomer(customerData).subscribe(o => {
                                this.getCustomers();
                                this.messagesService.loadingWindow.dismiss();
                                this.messagesService.displayToastWithMessage("Customer added", "customer added successfully");
                            });
                        }
                    }
                }
            ]
        });

        await alert.present();
    }

    async addCustomer(customerData) {
        await this.messagesService.presentLoadingWindow("Adding Customer...").then(async x => {
            await this.ApiCustomerService.addCustomer(customerData).subscribe(o => {
                this.getCustomers();
                this.messagesService.loadingWindow.dismiss();
                this.messagesService.addedSuccessfully("Customer");
            });

        });
    }


    async updateExistingCustomer(customerData) {
        await this.messagesService.presentLoadingWindow("Saving Customer...").then(async x => {
            await this.ApiCustomerService.updateCustomer(customerData.customerId, customerData).subscribe(o => {
                this.getCustomers();
                this.messagesService.loadingWindow.dismiss();
                this.messagesService.updatedSuccessfully("Customer");
            });
        });
    }

    async updateCustomerUsageLimit(usage) {
        await this.messagesService.presentLoadingWindow("Updating Customer Usage...").then(async x => {
            await this.ApiCustomerUsageService.postCustomerUsageLimitByCustomerId(usage).subscribe(a => {
                this.messagesService.loadingWindow.dismiss();
                this.messagesService.savedSuccessfully("Customer Usage");
            });
        });

    }

    communicateApi(urlParams): Observable<any> {
        var url = API_SETTINGS.API_URL + urlParams;
        return this.httpClient.get<any>(url);
    }

    getCustomerByCustomerId() {
        return new Promise<void>((resolve) => {
            this.ApiCustomerService.getCustomerByCustomerId(+this.cryptoService.decryptData(localStorage.getItem('customerId'))).subscribe(customerFromDb => {
                this.customer = customerFromDb;
                resolve();
            });
        });
    }

    getCustomers() {
        return new Promise<void>((resolve) => {
            this.ApiCustomerService.getCustomers().subscribe(customersFromDb => {
                this.customers = customersFromDb;
                resolve();
            });
        });
    }

    async deleteCustomer(customer) {
        const alert = await this.alertController.create({
            header: 'Please confirm',
            message: "are you sure you want to delete the customer '" + customer.name + "'?",
            buttons: [{
                text: 'Cancel',
            }, {
                text: 'Delete',
                handler: () => {
                    // Remove user;
                    this.messagesService.presentLoadingWindow("Deleting Customer...").then(x => {
                        this.ApiCustomerService.deleteCustomer(customer.customerId).subscribe(a => {
                            this.getCustomers();
                            this.messagesService.loadingWindow.dismiss();
                            this.messagesService.deletedSuccessfully("Customer");
                        });
                    });

                }
            }
            ]
        });
        await alert.present();
    }

    async updateCustomer(customer: Customer) {
        await this.messagesService.presentLoadingWindow("Updating Your Account...");
        this.ApiCustomerService.updateCustomer(customer.customerId, customer).subscribe(x => {
            this.getCustomerByCustomerId().then(x => {
                this.messagesService.loadingWindow.dismiss();
                this.messagesService.displayToastWithMessage("Your account", "was updated successfully");
            });
        });
    }

    checkLicense() {
        if (this.customer.licenseType == "Trial") {
            return true;
        }
        else {
            return this.checkIfExpired();
        }
    }

    CalculateDaysRemaining() {
        var today = new Date();
        var expiryDate = new Date(this.customer.expiryDate);
        var diff = Math.abs(today.getTime() - expiryDate.getTime());
        var days = Math.ceil(diff / (1000 * 3600 * 24));
        return days;
    }

    checkIfExpired() {
        var today = new Date();
        var expiryDate = new Date(this.customer.expiryDate);

        if (expiryDate < today) {
            this.hasExpired = true;
            return true;
        }
        else {
            this.hasExpired = false;
            return false;
        }
    }

    isTrialOrExpired() {
        if (this.customer == null) {
            this.getCustomerByCustomerId().then(x => {
                return this.checkLicense();
            });
        }
        else {
            return this.checkLicense();
        }
    }

    async getCustomerBlobStorage() {
        if (this.customer == null) {
            await this.getCustomerByCustomerId().then(x => {
                return this.customer.blobStorageLocation;
            });
        }
        else {
            return this.customer.blobStorageLocation;
        }
    }

    async getCustomerCurrency() {
        if (this.customer == null) {
            await this.getCustomerByCustomerId().then(x => {
                return this.getCurrency();
            });
        }
        else {
            return this.getCurrency();
        }
    }

    getCurrency() {
        if (this.ukList.includes(this.customer.country)) {
            return "GBP";
        }
        else if (this.euList.includes(this.customer.country)) {
            return 'EUR';
        }
        else {
            return 'USD';
        }
    }

    async openPackagePurchaseModal(packageToDisplay) {

        if (this._isModalOpen === true) return;
        this._isModalOpen = true;

        let prices = await this.getCustomerCurrency() == 'GBP' ? ["£2500", "£225", "£400", "£200", "£24", "£1900"] 
            : await this.getCustomerCurrency() == 'EUR' ? ["€3000", "€270", "€480", "€240", "€29", "€2280"] 
                : ["$3250", "$293", "$520", "$260", "$31", "$2470"];
                
        const packageModal = await this.modalController.create({
            component: PackagePurchaseModalPage,
            id: packageToDisplay == "credits" ? 'package-credits-modal' : 'package-purchase-modal',
            componentProps: {
                "packageToDisplay": packageToDisplay,
                "annual": prices[0],
                "annualMonthly": prices[1],
                "reporting": prices[2],
                "distribution": prices[3],
                "file": prices[4],
                "bundle": prices[5],

            },
        });

        packageModal.onDidDismiss().then(result => {
            this._isModalOpen = false;
        });

        return await packageModal.present();
    }

}